const modules = (channel) => {
  switch (channel) {
    case 'telegram':
      return (
        {
          modules: {
            toolbar: [
              ['bold', 'italic', 'link'],
            ],
          },
          formats: ['bold', 'italic', 'link'],
        }
      )
    case 'whatsapp':
    case 'smartchat':
      return (
        {
          modules: {
            toolbar: [
              ['bold', 'italic'],
            ],
          },
          formats: ['bold', 'italic'],
        }
      )
    case 'wall':
    case 'android':
    case 'ios':
    case 'chatweb':
      return (
        {
          modules: {
            toolbar: [
              [{ header: [1, 2, false] }],
              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
              [{ list: 'ordered' }, { list: 'bullet' }], //{ indent: '-1' }, { indent: '+1' }
              ['clean'],
            ],
          },
          formats: ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent'],
          modulesComment: {
            toolbar: [[{ header: [1, 2, false] }], ['bold', 'italic', 'underline', 'strike'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']],
          },
          formatsComment: ['header', 'bold', 'italic', 'underline', 'strike', 'list', 'bullet'],
        }
      )
    case 'chatmail':
      return (
        {
          modules: {
            toolbar: [
              [{ header: [1, 2, false] }],
              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['clean']
            ]
          },
          formats: ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list']
        }
      )
    default:
      return (
        {
          modules: {
            toolbar: []
          },
          formats: []
        }
      )
  }
}

export default modules
